import React from "react";
import PropTypes from "prop-types";
import { displayArchivoNombre } from "../utils/archivoDisplayName";
import { getMessage } from "../data/locales";

/**
 * Staff actions to inspect or save a course file without leaving course management.
 *
 * @param {{
 *   archivo: { nombre?: string, tipo?: string, url?: string, storageKey?: string },
 *   onOpen?: (archivo: { nombre?: string, tipo?: string, url?: string, storageKey?: string }) => void,
 *   onDownload?: (archivo: { nombre?: string, tipo?: string, url?: string, storageKey?: string }) => void,
 * }} props
 */
function CourseDocumentFileActions({ archivo, onOpen, onDownload }) {
  const fileLabel = displayArchivoNombre(archivo);

  return (
    <>
      {typeof onOpen === "function" ? (
        <button
          type="button"
          className="style2-button"
          aria-label={getMessage("courseEditor.documentOpenAria", { name: fileLabel })}
          onClick={() => {
            onOpen(archivo);
          }}
        >
          {getMessage("courseEditor.openDocument")}
        </button>
      ) : null}
      {typeof onDownload === "function" ? (
        <button
          type="button"
          className="style2-button"
          aria-label={getMessage("courseEditor.documentDownloadAria", { name: fileLabel })}
          onClick={() => {
            onDownload(archivo);
          }}
        >
          {getMessage("courseEditor.downloadDocument")}
        </button>
      ) : null}
    </>
  );
}

CourseDocumentFileActions.propTypes = {
  archivo: PropTypes.shape({
    nombre: PropTypes.string,
    tipo: PropTypes.string,
    url: PropTypes.string,
    storageKey: PropTypes.string,
  }).isRequired,
  onOpen: PropTypes.func,
  onDownload: PropTypes.func,
};

CourseDocumentFileActions.defaultProps = {
  onOpen: undefined,
  onDownload: undefined,
};

export default CourseDocumentFileActions;
